let ctx
let onEndCallback
export default {
    getCtx: () => {
        return ctx
    },
    start: (url, {
        onEnd
    }) => {
        if (!ctx) {
            ctx = wx.createInnerAudioContext()
        } else {
            onEndCallback && onEndCallback()
        }
        ctx.src = url
        onEndCallback = () => {
            if (typeof onEnd === 'function') {
                onEnd()
            }
        }
        wx.setInnerAudioOption({
            obeyMuteSwitch: false
        })
        ctx.onStop(() => {
            console.error('on stop')
            onEndCallback()
        })
        ctx.onEnded(() => {
            console.error('on end')
            onEndCallback()
        })
        ctx.onError((res) => {
            console.error('error', res)
            onEndCallback()
        })
        ctx.play()
    },
    stop () {
        console.error('stop', ctx)
        ctx && ctx.stop()
        onEndCallback && onEndCallback()
    },
    destroy () {
        ctx && ctx.destroy()
        ctx = null
    }
}
